import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import spinner from './../../assets/images/spinner.svg';

import './loader.css';

class Loader extends React.Component {
    render() {
        const { show, showOverride, message, progress } = this.props;
        if (!show && !showOverride) return null;

        let text = progress ? progress : message;

        return (
            <div className="loader">
                <div className="loader-message">
                    <img src={spinner} alt="loading" />
                    <span>{text}</span>
                </div>
            </div>
        );
    }
}

Loader.defaultProps = {
    message: <FormattedMessage id={'loading'} defaultMessage={'Loading...'} />,
    show: false,
    showOverride: false,
    progress: undefined
};

Loader.propTypes = {
    message: PropTypes.any,
    show: PropTypes.bool,
    showOverride: PropTypes.bool,
    progress: PropTypes.any
};

const mapStateToProps = state => ({
    show: state.loader.count > 0,
    message: state.loader.message,
    progress: state.loader.progress
});

export default connect(mapStateToProps, null)(Loader);



// WEBPACK FOOTER //
// ./src/components/loader/index.jsx